import androidx.compose.runtime.*
import kotlinx.coroutines.CancellationException
import kotlinx.coroutines.launch
import kotlinx.serialization.json.JsonObject
import org.jetbrains.compose.web.attributes.*
import org.jetbrains.compose.web.dom.*

@Composable
fun TourPublicVpp() {
    TourSeasonScope(null, showSeason = false, includeFinished = true) { season, _ -> key(season.id) {
        var rows by remember { mutableStateOf<List<JsonObject>>(emptyList()) }
        var error by remember { mutableStateOf<String?>(null) }
        var loading by remember { mutableStateOf(true) }
        var retry by remember { mutableStateOf(0) }
        LaunchedEffect(retry) {
            loading = true; error = null
            try { rows = TourSeasonResultsApi.vppSeason(season.id) }
            catch (e: Throwable) { if (e is CancellationException) throw e; error = e.apiMessage() }
            finally { loading = false }
        }
        Div(attrs = { classes("card") }) {
            H2 { Text("VPP · ${season.name}") }; TourError(error)
            if (error != null) Button(attrs = { onClick { retry++ } }) { Text("Načíst znovu") }
            if (loading) P { Text("Načítám VPP…") }
            else if (error == null) Div(attrs = { classes("table-scroll") }) {
                Table(attrs = { classes("public-table", "tour-score-table"); attr("aria-label", "VPP Tour") }) {
                    Thead { Tr { listOf("Datum", "Turnaj", "Obsah", "Výherní nához", "Výherce").forEach { Th(attrs = { attr("scope", "col") }) { Text(it) } } } }
                    Tbody {
                        val publishedRows = rows.mapNotNull { row -> row.obj("vpp")?.obj("published")?.let { row to it } }
                        if (publishedRows.isEmpty()) Tr { Td(attrs = { colspan(5) }) { Text("VPP zatím nebylo zveřejněno.") } }
                        publishedRows.forEach { (row, published) -> Tr {
                            Td { Text(row.text("starts_on").takeIf { it.isNotEmpty() }?.let(::formatDate) ?: "—") }
                            Td { Text(row.text("title")) }
                            Td { Text(published.text("amount").toDoubleOrNull()?.let { "${it.asDynamic().toFixed(0) as String} Kč" } ?: "—") }
                            Td { Text(published.strings("numbers").joinToString(", ").ifEmpty { "—" }) }
                            Td(attrs = { classes("tour-player-name") }) { Text(published.objects("winners").joinToString(", ") { it.text("player_full_name").ifBlank { it.text("player_name") } }.ifEmpty { "—" }) }
                        } }
                    }
                }
            }
        }
    } }
}
